import { useState } from 'react';
import { Alert, Button, Grid, TextField } from '@mui/material';
import { patchSettings } from '../../services/adminService';
import { gradientButtonStyling } from '../../assets/styling/buttons';

function Prices({
  defaultPriceUsedCar,
  defaultPriceNewCar,
  defaultPriceUsedCarRepolish,
  defaultPriceNewCarRepolish
}) {
  const [priceUsed, setPriceUsed] = useState(defaultPriceUsedCar || 0);
  const [priceNew, setPriceNew] = useState(defaultPriceNewCar || 0);
  const [priceUsedRepolish, setPriceUsedRepolish] = useState(defaultPriceUsedCarRepolish || 0);
  const [priceNewRepolish, setPriceNewRepolish] = useState(defaultPriceNewCarRepolish || 0);
  const [saveMsg, setSaveMsg] = useState('');
  const [saveSeverity, setSaveSeverity] = useState('');

  const onChangePriceUsed = (e) => {
    setPriceUsed(e.target.valueAsNumber ? e.target.valueAsNumber : null);
  };
  const onChangePriceNew = (e) => {
    setPriceNew(e.target.valueAsNumber ? e.target.valueAsNumber : null);
  };
  const onChangePriceUsedRepolish = (e) => {
    setPriceUsedRepolish(e.target.valueAsNumber ? e.target.valueAsNumber : null);
  };
  const onChangePriceNewRepolish = (e) => {
    setPriceNewRepolish(e.target.valueAsNumber ? e.target.valueAsNumber : null);
  };
  const onSave = () => {
    patchSettings(priceNew, priceUsed, priceNewRepolish, priceUsedRepolish)
      .then(() => {
        setSaveMsg('Gegevens opslagen');
        setSaveSeverity('success');
      })
      .catch((err) => {
        setSaveMsg(`Opslaan mislukt: ${err}`);
        setSaveSeverity('error');
      });
  };

  return (
    <Grid container>
      <Grid item xs={12} md={4}>
        <h2>Prijzen</h2>
        <TextField
          sx={{ mb: 1 }}
          label="Gebruikt"
          type="number"
          value={priceUsed}
          onChange={onChangePriceUsed}
        />
        <TextField
          sx={{ mb: 1 }}
          label="Nieuw"
          type="number"
          value={priceNew}
          onChange={onChangePriceNew}
        />
        <TextField
          sx={{ mb: 1 }}
          label="Gebruikt Napoetsen"
          type="number"
          value={priceUsedRepolish}
          onChange={onChangePriceUsedRepolish}
        />
        <TextField
          sx={{ mb: 1 }}
          label="Nieuw Napoetsen"
          type="number"
          value={priceNewRepolish}
          onChange={onChangePriceNewRepolish}
        />
        <Button
          sx={[gradientButtonStyling, { mt: 2, p: 1.5 }]}
          variant="contained"
          onClick={onSave}
        >
          Opslaan
        </Button>
        {saveMsg && (
          <Alert sx={{ mt: 2 }} severity={saveSeverity}>
            {saveMsg}
          </Alert>
        )}
      </Grid>
    </Grid>
  );
}

export default Prices;
